<template>
  <section class="pa-section pa-section-transparent pa-section-home-credit-field">
    <div class="version">
      <p>塔経市帝異界越境用特別表示器ー開発番号：{{applicationVersion}}</p>
    </div>

    <div class="reload-button">
      <button
       class="button pa-forceful-reload-button"
       :class="additionalReloadButtonClass"
       :disabled="isDisabledReloadButton"
       @click="handleClickReloadApp"
      >アプリの再読み込み</button>
    </div>

    <div class="link">
      <button
       @click.prevent="handleClickTerms"
      >利用規約</button>
      &nbsp;/&nbsp;
      <button
       @click.prevent="handleClickPrivacy"
      >プライバシーポリシー</button>
    </div>

    <div class="link link-tokusho" v-if="isShowTokusho === 'true'">
      <button
       @click.prevent="handleClickTokusho"
      >特定商取引法に基づく表記</button>
    </div>

    <div class="copyright">
      <p>(C) Copyright 24th ward Administration Bureau of Parallel Universe.</p>
    </div>

    <PALoginedTermsModal />
    <PALoginedPrivacyModal />
    <PALoginedTokushoModal />
  </section>
</template>

<script>
import PALoginedTermsModal   from '@/components/Parts/PALoginedTermsModal/PALoginedTermsModal.vue'
import PALoginedPrivacyModal from '@/components/Parts/PALoginedPrivacyModal/PALoginedPrivacyModal.vue'
import PALoginedTokushoModal from '@/components/Parts/PALoginedTokushoModal/PALoginedTokushoModal.vue'

export default {
  components : {
    PALoginedTermsModal,
    PALoginedPrivacyModal,
    PALoginedTokushoModal
  },

  data(){
    return {
      applicationVersion          : '',

      isLoadingReloadButton       : false,
      additionalReloadButtonClass : {
        'is-loading'  : false
      },
      isDisabledReloadButton      : false
    };
  },

  watch : {
    isLoadingReloadButton : {
      handler(value){
        this.isDisabledReloadButton = value;
        this.additionalReloadButtonClass['is-loading'] = value;
      }
    }
  },

  computed : {
    isShowTokusho(){
      return process.env.VUE_APP_IS_SHOW_TOKUSHO;
    }
  },

  methods : {
    handleClickTerms(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['open_terms_modal'] = 'yes';
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },
    
    handleClickPrivacy(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['open_privacy_modal'] = 'yes';
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    handleClickTokusho(){
      const newUrlQuery = Object.assign({}, this.$route.query);

      newUrlQuery['open_tokusho_modal'] = 'yes';
      newUrlQuery['y'] = window.scrollY;

      this.$router.push({
        name    : this.$route.name,
        params  : this.$route.params,
        query   : newUrlQuery
      });
    },

    async handleClickReloadApp(){
      this.isLoadingReloadButton = true;

      await this.UXWaiting(500);

      if(!this.forcefulReloading()){
        this.isLoadingReloadButton = false;
      }
    }
  },

  mounted(){
    this.applicationVersion = process.env.VUE_APP_PA_APPLICATION_VERSION;
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

.pa-section{
  &-home-credit-field{
    text-align: center;
    font-size:.8rem;
    color: #7e1f47;
    padding-top:0 !important;

    @include until(375px) {
      font-size:.74rem;
    }

    div.version{
      margin-bottom:.5rem;
    }

    div.reload-button{
      button.pa-forceful-reload-button{
        margin:.4rem 0 .8rem;
        background-color:#8d3a5c;
        color:#791a42;
        border:1px solid #8d3a5c;
        border-radius: 8px;
        padding:4px 12px;
        height: inherit;
        font-size:.85rem;
        line-height: 1.2;

        &.is-loading::after{
          border: 1.3px solid #791a42;
          border-right-color: transparent;
          border-top-color: transparent;
        }
      }
    }

    div.copyright{
      font-size: .62rem;

      @include from($tablet) {
        font-size: .8rem;
      }

      @include until(375px) {
        font-size: .5rem;
      }
    }

    div.link{
      a{
        color: #7e1f47;
        font-weight: bold;
      }

      button{
        padding:0;
        border:0;
        background-color:inherit;
        color: #7e1f47;
        font-weight: bold;
        cursor: pointer;

        @include until(375px) {
          font-size:.8rem;
        }
      }

      &-tokusho{
        margin:.3rem 0 .4rem;
        button{
          font-size: .65rem;
        }
      }
    }
  }
}
</style>